<div class="form-container">
    <label [for]="id" *ngIf="label">{{label}}</label>
    <ng-container [ngSwitch]="type">
        <ng-container *ngSwitchCase="'textarea'">
            <div class="input-container" style="align-items: flex-start !important;" [ngClass]="{'disabled': disabled}">
                <i class="fa-duotone fa-text-size" style="margin:8px;"></i>
                <textarea *ngIf="!autoSizeTextarea" [id]="id" [rows]="rows" [formControl]="formControl" [placeholder]="placeholder"
                          style="padding-top: 6px; font: inherit;"></textarea>
                <textarea *ngIf="autoSizeTextarea" [id]="id" [formControl]="formControl" [placeholder]="placeholder"
                          style="padding-top: 6px; font: inherit;"
                          cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                          [cdkAutosizeMinRows]="rows"
                          [cdkAutosizeMaxRows]="rows"></textarea>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'search'">
            <div class="input-container">
                <i class="fa-duotone fa-magnifying-glass" style="margin:8px;"></i>
                <div class="divider" style="height: 28px; border-top: 0;"></div>
                <input [id]="id" [formControl]="formControl" [placeholder]="placeholder" />
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'input'">
            <div class="input-container" [ngClass]="{'disabled': disabled}">
                <i class="fa-duotone fa-text-size" style="margin:8px;"></i>
                <div class="divider" style="height: 28px; border-top: 0;"></div>
                <input [id]="id" [formControl]="formControl" [placeholder]="placeholder"
                       [autocomplete]="autocomplete" />
            </div>
        </ng-container>
    </ng-container>
</div>